import React, { useState } from 'react'
import { Loader2, Trash2 } from "lucide-react"
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';
import { showError, showSuccess } from '../../../utils/alert';
import { logoutStore } from '../../../redux/storeSlice';
import { apiDelete } from '../../../utils/api';
import { getStoreAccessToken } from '../../../utils/auth';
import { useUpdateResource } from '../../../hooks/useUpdateResource';

function DeleteStoreAccount() {
    const {t} = useTranslation();

      const dispatch = useDispatch();
      
         const {loading,updateResource} = useUpdateResource();
          
        
           const onSubmit= async () => {
                   const res = await  updateResource(`deletion/soft-store`, {}, "store",{
                        method: "DELETE",
                        successMessage: t("deleted_account"),
                        confirmMessage:t("general_confirm_message")
                      });
                      if(res === true){
                        dispatch(logoutStore());
                      }
              };

  return (
     <div className="p-6 rounded-2xl border border-gray-200 shadow-sm bg-white max-w-md mx-auto mt-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="bg-red-100 text-red-600 p-2 rounded-full">
          <Trash2 className="w-5 h-5" />
        </div>
      </div>

      <p className="text-sm text-gray-600 leading-relaxed mb-5">
        {t("account_deletion_warning")}
      </p>

      <button
        onClick={onSubmit}
        disabled={loading}
        className={`w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-white font-medium transition-all duration-200
          ${loading ? "bg-red-400 cursor-not-allowed" : "bg-red-600 hover:bg-red-700"}
        `}
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            {t("deleting")}
          </>
        ) : (
          <>
            <Trash2 className="w-4 h-4" />
            {t("delete")}
          </>
        )}
      </button>
    </div>
  )
}

export default DeleteStoreAccount